import { type HttpDelete, mapServerError } from '@/shared/infra/http'
import {
  GalleryPhotoAccessDeniedError,
  GalleryPhotoNotFoundError,
} from '@/shared/domain'
import type { DeleteGalleryPhoto } from '@/modules/gallery/use-cases'

export class SupabaseDeleteGalleryPhotoRepository {
  constructor(private readonly http: HttpDelete) {}

  execute: DeleteGalleryPhoto = async ({ id }) => {
    try {
      await this.http.delete<void>({
        url: `/club-gallery-photos/${encodeURIComponent(id)}`,
      })
    } catch (err) {
      mapServerError(err, {
        '403:access_denied': GalleryPhotoAccessDeniedError,
        '404:not_found': GalleryPhotoNotFoundError,
      })
    }
  }
}
